import axios from '../lib/axios'
import { getCsrfToken } from '../Util/postRequest'

export const getCartItemsApi = async () => {
  try {
    return await axios.get('/api/v1/user/carts')
  } catch (error) {
    throw new Error(error.message)
  }
}

// params: { content_id: "CONTENT_ID" }
export const createCartItemApi = async (params) => {
  return await axios.post('/api/v1/user/carts', params, {
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
  })
}

// params: { contents: [{ content_id: "CONTENT_ID" }], ... }
export const createCartItemsApi = async (params) => {
  return await axios.post('/api/v1/user/carts/bulk_insert', params, {
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
  })
}

export const removeCartItemsApi = async (contentIds) => {
  return await axios.delete('/api/v1/user/carts/bulk_destroy', {
    data: { content_ids: contentIds },
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
  })
}
